import { render, staticRenderFns } from "./Winners.vue?vue&type=template&id=f65f04d8&scoped=true"
import script from "./Winners.vue?vue&type=script&lang=js"
export * from "./Winners.vue?vue&type=script&lang=js"
import style0 from "./Winners.vue?vue&type=style&index=0&id=f65f04d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65f04d8",
  null
  
)

export default component.exports